<template>
  <div>
      <v-container fluid>
        <v-row align="center">
          <span class="ml-3 text-subtitle-2 text-title">{{ title }}</span>
          <v-progress-circular size="35" :value="percent" :color="getColor()" class="ml-3">
            <span class="percent-avatar text-subtitle-2"> {{ toFixed(value) }} </span>
          </v-progress-circular>
        </v-row>
      </v-container>
  </div>
</template>

<script>

export default {
  name: 'BaseCircleIndicator',
  props:
  {
    'title': {type: [String], default: null},
    'value': {type: [Number], default: 0},
    'percent': {type: [Number], default: 100},
    'value_green': {type: [Number], default: 10},
    'value_red': {type: [Number], default: 20},
  },
  data() {
    return {
      backColor: "purple lighten-5",
    }
  },

  components: {
  },

  methods: {
    getDateRange() {
      return this.item.date_day[0] + ' - ' + item.date_day[4]
    },
    toFixed(value) {
      return value.toFixed(0)
    },
    toPercent(value) {
      return (value * 100).toFixed(0)
    },
    getColor() {
      if (this.value_green > this.value_red) {
        if (this.value >= this.value_green)
          return "green accent-4"
        if (this.value < this.value_red)
          return "red accent-2"
        return "yellow accent-4"
      }
      else {
        if (this.value < this.value_green)
          return "green accent-4"
        if (this.value >= this.value_red)
          return "red accent-2"
        return "yellow accent-4"
      }
    },
  },

  mounted() {
  },

}
</script>

<style scoped lang="scss">

* {
  font-size: 14px;
  font-weight: bold;
}

.year-week, .deliveries {
  color: white;
}

.text-title, .percent-avatar {
  color: lightgrey;
}

</style>